import { render, staticRenderFns } from "./PromotionRewardSelector.vue?vue&type=template&id=8fabe57c&"
import script from "./PromotionRewardSelector.vue?vue&type=script&lang=js&"
export * from "./PromotionRewardSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports